module.exports = __webpack_public_path__ + "static/media/warningDetect.128e9826.svg";